import { createEventEmitter } from '@lib/event-emitter';
import once from '@lib/once';

const tileWidth = 286;
const tilesGap = 32;
const animationBreakpoint = 4 * tileWidth + 3 * tilesGap;
const resize = createEventEmitter();

function zeroOnMobile(value: number): number {
    if (window.innerWidth < animationBreakpoint) return 0;
    return value;
}

function initTile(tile: HTMLDivElement): void {
    const content = tile.querySelector<HTMLDivElement>('.tile__content');
    const actions = tile.querySelector<HTMLDivElement>('.tile__actions');
    const bodyCopy = tile.querySelector<HTMLDivElement>('.body-copy');
    const bodyCopyMargin = bodyCopy ? parseInt(window.getComputedStyle(bodyCopy).marginBottom) : 0;

    const getHeight = (el?: HTMLElement | null) => (el ? el.clientHeight : 0);

    const expand = () => {
        if (content) content.style.transform = `translateY(0px)`;
    };
    const collapse = () => {
        if (content) {
            content.style.transform = `translateY(${zeroOnMobile(
                getHeight(actions) + getHeight(bodyCopy) + bodyCopyMargin
            )}px)`;
        }
    };

    tile.addEventListener('mouseenter', expand);
    tile.addEventListener('mouseleave', collapse);
    resize.addEventListener('mobile', expand);
    resize.addEventListener('desktop', collapse);
    collapse();
}

window.Drupal.behaviors['small-tile'] = {
    attach: function (context) {
        context.querySelectorAll<HTMLDivElement>('.small-tiles .tile.tile--image').forEach((tile) => {
            once('tile', () => initTile(tile), [tile]);
        });
    },
};

let mobile: boolean;
function reactToResize() {
    const isMobile = window.innerWidth < animationBreakpoint;
    if (isMobile !== mobile) {
        mobile = isMobile;
        resize.emit(mobile ? 'mobile' : 'desktop');
    }
}

window.addEventListener('resize', reactToResize, { passive: true });
reactToResize();
